module.exports = __webpack_public_path__ + "img/elvis-fanday-82.018f0e90.jpg";